import { Component } from '@angular/core';
import { NgForOf, UpperCasePipe } from '@angular/common';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatasetTypeEnum } from '../../../../shared/dataset/model/dataset-type.enum';
import { SubObservationUnitDatasetBuilderModalComponent } from './sub-observation-unit-dataset-builder-modal.component';
import { SubObservationInfoModel } from './sub-observation-info.model';

@Component({
    selector: 'jhi-sub-observation-unit-type-selector-modal',
    templateUrl: './sub-observation-unit-type-selector-modal.component.html',
    styleUrl: './sub-observation-unit-type-selector-modal.component.scss'
})
export class SubObservationUnitTypeSelectorModalComponent {

    constructor(private activeModal: NgbActiveModal,
                private modalService: NgbModal) {}

    subObservationInfoModels: SubObservationInfoModel[] = [{
        id: DatasetTypeEnum.PLANT_SUBOBSERVATIONS,
        label: 'study-editor.dataset.label-plants',
        name: 'plants',
        defaultVariableId: 8206,
        alias: 'plants'
    }, {
        id: DatasetTypeEnum.QUADRAT_SUBOBSERVATIONS,
        label: 'study-editor.dataset.label-quadrats',
        name: 'quadrats',
        defaultVariableId: 8207,
        alias: 'quadrats'
    }, {
        id: DatasetTypeEnum.TIME_SERIES_SUBOBSERVATIONS,
        label: 'study-editor.dataset.label-time-series',
        name: 'time series',
        defaultVariableId: 8205,
        alias: 'time points'
    }, {
        id: DatasetTypeEnum.CUSTOM_SUBOBSERVATIONS,
        label: 'study-editor.dataset.label-custom',
        name: 'sub-observation units',
        defaultVariableId: undefined,
        alias: 'sub-observation units'
    }];

    selectedDatasetType: any;

    cancel() {
        this.activeModal.dismiss();
    }

    dataSetTypeSelected(datasetType: any) {
        this.selectedDatasetType = datasetType;
    }

    continue() {
        const modalRef = this.modalService.open(SubObservationUnitDatasetBuilderModalComponent as Component, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.selectedDatasetType = this.selectedDatasetType;
        modalRef.componentInstance.subObservationInfoModels = this.subObservationInfoModels;
        modalRef.result.then((result) => {
            this.activeModal.close(result);
        });
    }
}
